<template>
    <div class="row g-6 g-xl-9">
        <div class="col-12 col-md-12 col-xl-12">  
            <CardRh >
                <div class="col-12 col-md-12  min-h-1850px"> 
                    <iframe :src="url" width="100%" height="1000px"   style="border: none;"></iframe>   
                </div>   
            </CardRh>
        </div>
    </div>
</template>

<script lang="ts"> 
    import MatriculaService from   "@/service/v1/sigap/MatriculaService"  
    import { Options, Vue } from "vue-class-component"; 
    import CardRh from   "@/components/cards/ManzaCard.vue"  
    import {  Prop  , Watch } from 'vue-property-decorator';  
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 

    @Options({
        name: "HistoricoIndex",
        components: {  CardRh   },
    }) 
    export default class HistoricoIndex extends Vue {
        
        @Prop( ) readonly matricula!: any  
          
        @authStore.Getter
		public token!: any 
        
        public service = new MatriculaService();
         
        public url: any = "";
         
        created(){ 
            this.url = this.service.getApiUrl() + '/' + this.matricula.id + '/boletim/pdf' + '?token=' + this.token ;  
        } 
   
    } 
  
</script>